import type { MouseEvent } from "react";
import styles from "./StoryRail.module.scss";

/* UI-DESIGN: LB-14 scroll progress for the live scene: where you are in
   the story and a way to jump. A real nav of in-page links, so it is also
   a table of contents for keyboard and screen-reader users. */
type StoryRailProps = {
  chapters: { id: string; label: string }[];
  active: number;
};

const StoryRail = ({ chapters, active }: StoryRailProps) => {
  const go = (e: MouseEvent<HTMLAnchorElement>, id: string) => {
    const el = document.getElementById(id);
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    history.replaceState(null, "", `#${id}`);
  };
  return (
    <nav className={styles.rail} aria-label="Sections on this page">
      <ol>
        {chapters.map((c, i) => (
          <li key={c.id}>
            <a
              href={`#${c.id}`}
              className={styles.link}
              aria-current={i === active ? "location" : undefined}
              onClick={(e) => go(e, c.id)}
            >
              <span className={styles.tick} aria-hidden />
              <span className={styles.label}>{c.label}</span>
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default StoryRail;
